<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_Size') +' - ' + this.$t('CargoMsg.Cargo_Edit')"
    width="550px"
    append-to-body
    :close-on-click-modal="false"
    :destroy-on-close="true"
    class="main-content"
  >
    <div class="section" style="width: 100%">
      <el-form
        label-position="left"
        label-width="80px"
        style="width: 100%;"
      >
        <div>
          <span style="font-size: 16px">{{ from.text }}</span>
        </div>
        <div>
          <cargo-ag-grid
            ref="dimensions"
            :show-side-bar="false"
            :grid-options="options"
            :column-defs="column"
            :row-data="rowData"
            style="width: 100%;min-width: 180px"
            @gridReady="params=>{gridApi=params.api}"
          />
        </div>
      </el-form>
      <div style="display: flex">
        <div style="display: flex; text-align: left; align-items: center; font-size: 20px; width: 50%">
          <span>{{ $t('CargoMsg.Cargo_BatchEnterDimensions') }}</span>
        </div>
        <div style="text-align: right; padding-top: 5px; padding-bottom: 5px; width: 50%">
          <el-button type="primary" @click="empty2Handler">{{ $t('CargoMsg.Cargo_Empty') }}</el-button>
          <el-button type="default" @click="estimatedDeliveryHandler">{{
            $t('CargoMsg.Cargo_Recognition')
          }}
          </el-button>
        </div>
      </div>
      <div style="display: flex;">
        <el-input v-model="from.notes" no="notes" type="textarea" :placeholder="$t('CargoMsg.Cargo_ReadingTip')" :rows="5" size="min" />
      </div>
    </div>
    <div slot="footer" style="text-align: right">
      <el-button type="primary" @click="okHandler">{{ $t('SeaExport.Confirm') }}</el-button>
      <el-button type="default" @click="emptyHandler">{{ $t('CargoMsg.Cargo_Empty') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { DocumentManage } from '@/utils/commonUtil'
import { getUuid } from '@/utils'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor/index.vue'
import * as NumberUtils from '@/utils/NumberUtils'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'

export default {
  name: 'DimensionsDialog',
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    uuid: {
      type: String,
      default: ''
    },
    dimension: {
      type: String,
      default: ''
    },
    openImperial: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      documentManage: new DocumentManage(),
      gridApi: null,
      options: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        singleClickEdit: true,
        selectedRowIndex: -1,
        context: {
          componentParent: this
        },
        frameworkComponents: {
          CargoAgGridCommonInputEditor
        },
        columnApi: null
      },
      addKey: 'dimensions_',
      from: {
        notes: '',
        text: '',
        cubAgeSum: 0.000, // 公制
        cubAgeImperial: 0.000 // 英制
      },
      rowData: [],
      column: [
        {
          headerName: ' ',
          field: 'operation',
          suppressMenu: true,
          editable: false,
          width: 100,
          cellRenderer: params => {
            const onDel = this.documentManage.getPath('onDel')
            const onAdd = this.documentManage.getPath('onAdd')
            return `<div><a onclick="${onAdd}()" style="color:#1F75D5;font-size:25px;">+</a><a onclick="${onDel}('${params.data.uuid}')" style="color:#1F75D5;font-size:25px;">-</a></div>`
          }
        },
        {
          headerName: this.$t('Warehouse.boxLengthPlaceholder') + (this.openImperial ? '(in)' : '(CM)'),
          field: 'length', colId: 'length',
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('Warehouse.boxWidthPlaceholder') + (this.openImperial ? '(in)' : '(CM)'),
          field: 'width', colId: 'width',
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('Warehouse.BoxHeightPlaceholder') + (this.openImperial ? '(in)' : '(CM)'),
          field: 'height', colId: 'height',
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('Warehouse.NumberOfCases'),
          field: 'quantity', colId: 'quantity',
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0')
          },
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 0
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        }
      ]
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        }
      }
    }
  },
  beforeMount() {
    const context = this
    this.documentManage.set('onAdd', function(value) {
      context.onAdd(value)
    })
    this.documentManage.set('onDel', function(value) {
      context.onDel(value)
    })
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      if (this.dimension) {
        this.doEstimatedDeliveryHandler(this.dimension)
      }
      if (!this.rowData || this.rowData.length === 0) {
        this.onAdd()
      }
    },
    onAdd() {
      const row = {}
      row.uuid = this.addKey + getUuid()
      row.length = 0
      row.width = 0
      row.height = 0
      row.quantity = 0
      this.rowData.push(row)
    },
    onDel(uuid) {
      if (uuid !== null) {
        this.rowData = this.rowData.filter(row => row.uuid !== uuid)
      }
      if (this.rowData.length === 0) {
        this.onAdd()
      }
      this.calcSumData()
    },
    onCancel() {
      this.$emit('close')
    },
    okHandler() {
      let dimension = ''
      for (const row of this.rowData) {
        if (dimension) {
          dimension += ';'
        }
        dimension += `${row.length}*${row.width}*${row.height}*${row.quantity}`
      }
      this.$emit('sizeData', { dimension: dimension, uuid: this.uuid, cubAgeSum: this.from.cubAgeSum, cubAgeImperial: this.from.cubAgeImperial })
      this.onCancel()
    },
    // 清空
    emptyHandler() {
      this.from.notes = ''
    },
    // 清空列表
    empty2Handler() {
      this.rowData = []
      this.onAdd()
      this.calcSumData()
    },
    // 识别
    estimatedDeliveryHandler() {
      this.doEstimatedDeliveryHandler(this.from.notes)
    },
    doEstimatedDeliveryHandler(value) {
      if (value) {
        this.rowData = []
        // 使用正则表达式一次性替换所有目标字符
        value = value.replace(/[,，；/Xx\n]/g, match => ({
          ',': ';',
          '，': ';',
          '；': ';',
          '\n': ';',
          'X': '*',
          'x': '*',
          '/': '*'
        })[match])
        const list = value.split(';')
        for (const data of list) {
          if (!data) {
            continue
          }
          const dataList = data.split('*')
          // 提前校验输入格式，避免后续无效操作
          if (dataList.length !== 4) {
            this.$message.warning(this.$t('CargoMsg.Cargo_EstimatedDeliveryDateError'))
            break
          }
          const [length, width, height, quantity] = dataList.map(Number)
          // 若转换后的数值有NaN，也提示错误
          if (isNaN(length) || isNaN(width) || isNaN(height) || isNaN(quantity)) {
            this.$message.warning(this.$t('CargoMsg.Cargo_EstimatedDeliveryDateError'))
            break
          }
          this.rowData.push({
            uuid: this.addKey + getUuid(),
            length,
            width,
            height,
            quantity
          })
        }
      }
      this.calcSumData()
    },
    onCellChange(p) {
      this.calcSumData()
    },
    async calcSumData() {
      let quantitySum = 0
      let weightSum = 0
      let cubAgeSum = 0
      let volumeSum = 0
      for (const detail of this.rowData) {
        let volume = 1
        quantitySum += Number(detail.quantity)
        const dimension = `${detail.length}*${detail.width}*${detail.height}*${detail.quantity}`
        let r = []
        // 是英制的转成公制的
        if (this.openImperial) {
          const dimensionIm = await JobUtils.calculateDimension(detail.length, detail.width, detail.height, detail.quantity)
          r = dimensionIm.split('*')
        } else {
          r = dimension.split('*')
        }
        for (const n of r) {
          volume *= n
        }
        volumeSum += volume
      }
      quantitySum = NumberUtils.ToFixed2(quantitySum, 0)
      // volumeSum 最后一定是公制的
      cubAgeSum = NumberUtils.ToFixed2(volumeSum / 1000 / 1000, 3) // 获取体积
      weightSum = NumberUtils.ToFixed2(volumeSum / 6000, 3) // 获取获取体积重量
      // 计算出英制的
      const cubAgeSumIm = await JobUtils.calculateCubAge(cubAgeSum, true)
      const weightSumIm = await JobUtils.calculateWeight(weightSum, true)
      this.from.cubAgeSum = cubAgeSum // 公制
      this.from.cubAgeImperial = cubAgeSumIm // 英制
      this.from.text = this.$t('CargoMsg.Cargo_ItemsNBR') + ` : ${quantitySum} ${this.$t('SeaExport.Piece')}, ` +
        this.$t('CargoMsg.Cargo_Cubage') + `: ` + (this.openImperial ? `${cubAgeSumIm}CFT, ` : `${cubAgeSum}CBM, `) +
        this.$t('CargoMsg.Cargo_VolumeWeight') + `: ` + (this.openImperial ? `${weightSumIm}LB` : `${weightSum}KG`)
    }
  }
}
</script>

<style scoped>

</style>
